<template>
  <div class="loop-box" @click="openLink">
    <div class="loop-box-title">{{ title }}</div>
    <vue-seamless-scroll
      :data="listData"
      :class-option="realClassOption"
      class="warp"
    >
      <ul class="ul-item">
        <li
          class="li-item"
          :class="{ 'use-cursor': item.link }"
          :style="itemStyle"
          v-for="(item, index) in listData"
          :key="index"
        >
          <img :src="item.icon" :data-link="item.link" />
        </li>
      </ul>
    </vue-seamless-scroll>
  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll';
import bridge from '@utiles/bridge';
import { mapState } from 'vuex';

export default {
  name: 'LoopBox',
  props: {
    title: {
      type: String,
      default: ''
    },
    listData: {
      type: Array,
      default: () => [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    },
    itemStyle: {
      type: Object,
      default: () => ({
        width: '64px',
        height: '64px'
      })
    },
    classOption: {
      type: Object,
      default: () => ({
        limitMoveNum: 6,
        direction: 2
      })
    }
  },
  computed: {
    ...mapState({
      isLandscape: state => state.page.isLandscape
    }),
    realClassOption() {
      return {
        ...this.classOption,
        hoverStop: this.isLandscape
      };
    }
  },
  methods: {
    openLink(e) {
      const link = e.target?.dataset?.link;
      if (!link) return;
      if (bridge.runInsdk()) {
        bridge.callSdkMethod('openWebView', {
          url: link,
          loginDir: 0,
          appendParams: 0
        });
      } else {
        window.open(link, '_blank');
      }
    }
  },
  components: {
    vueSeamlessScroll
  }
};
</script>

<style scoped lang="scss">
.loop-box {
  margin-bottom: 40px;
  &-title {
    margin-bottom: 40px;
    font-size: 24px;
    color: #333333;
  }
  .warp {
    width: 90%;
    overflow: hidden;
    .ul-item {
      list-style: none;
      padding: 0;
      margin: 0 auto;
      display: flex;
      .li-item {
        overflow: hidden;
        box-sizing: border-box;
        margin-right: 44px;
        padding: 2px;
        text-align: center;
        &.use-cursor {
          cursor: pointer;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          object-position: center;
        }
      }
    }
  }
}

#ssr-page.landscape {
  .loop-box {
    &-title {
      margin-bottom: 20px;
      font-size: 14px;
      color: #ffffff;
    }
    .warp {
      .ul-item {
        .li-item {
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
